import React from "react";
import {
  HeroSection,
  ProgressSection,
  WhoWeAre,
  Features,
  WhyChooseUs,
  Trainers,
  HomeTestimonial,
  GymLogos,
  HomeGallery,
  Bmi,
  HomePricing,
  HomeBlogs,
  FitnessTrainer,
  Footer,
} from "../../Components/HomepageComponents/Import";

const HomePage = () => {
  return (
    <>
      <HeroSection />
      <ProgressSection />
      <WhoWeAre />
      <Features />
      <WhyChooseUs />
      <Trainers />
      <HomeTestimonial />
      <GymLogos />
      <HomeGallery />
      <Bmi />
      <HomePricing />
      <HomeBlogs />
      <FitnessTrainer />
      <Footer />
    </>
  );
};

export default HomePage;
